module.exports = __webpack_public_path__ + "static/img/img12.e60f365.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img12.png
// module id = lX4m
// module chunks = 1